
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules/service-terms",
      function () {
        return require("private-next-pages/rules/service-terms/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules/service-terms"])
      });
    }
  